import { throwError } from "../../../utils/helper";

type Item = {
  image_attachment_id: string;
  title: string;
  subtitle: string;
  cta_redirection_type: string;
  is_expandable: boolean;
  cta_text: string;
};
type HeaderTags = {
  text: string;
  color: string;
};
class HeroContent {
  /* sole purpose of variables declared below are 
  documentation reference purpose only */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  header!: string;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  header_tags!: HeaderTags[];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  items: Item[] = [];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  show_item_details!: boolean;

  getSerializedData = (widgetFormData: HeroContent) => {
    let itemModified = widgetFormData?.items?.map((item: Item) => {
      return {
        ...item,
        is_expandable: Boolean(item.is_expandable),
      };
    });
    widgetFormData.items = itemModified;
    return widgetFormData;
  };
  getDeSerializedData = (widgetFormData: HeroContent) => {
    return widgetFormData;
  };

  headerValidator = async (rule: any, value: any) => {
    if (!value) return Promise.resolve();
  };
  headerTagsTextValidator = async (rule: any, value: any) => {
    if (!value) throwError("Header tags text required!");
  };
  headerTagsColorValidator = async (rule: any, value: any) => {
    if (!value) throwError("Header tags color required!");
  };
  imageAttachmentValidator = async (rule: any, value: any) => {
    if (!value) throwError("Thumbnail Image required!");
  };
  titleValidator = async (rule: any, value: any) => {
    if (!value) throwError("Title required!");
  };
  subtitleValidator = async (rule: any, value: any) => {
    if (!value) throwError("Subtitle required!");
  };
  redirectionTypeValidator = async (rule: any, value: any) => {
    if (!value) throwError("Redirection type required!");
  };
  ctaTextValidator = async (rule: any, value: any) => {
    if (!value) throwError("CTA Text required!");
  };
}
export default HeroContent;
export const HeroContentInstance = new HeroContent();
